export type LiveMonitorStatMetrics = {
    activeCalls: number;
    queued: number;
    pending: number;
    avgDurationSeconds: number | null;
};

export const EMPTY_LIVE_MONITOR_STATS: LiveMonitorStatMetrics = {
    activeCalls: 0,
    queued: 0,
    pending: 0,
    avgDurationSeconds: null,
};

export const formatAvgDuration = (seconds: number | null): string => {
    if (seconds == null || Number.isNaN(seconds) || seconds <= 0) return '—';

    const totalSeconds = Math.round(seconds);
    const minutes = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;

    if (minutes === 0) return `${secs}s`;
    return `${minutes}m ${secs.toString().padStart(2, '0')}s`;
};
